import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModalButton/ProductGalleryBlockModalButton.styles';
import Icon from '@components/icons/Icon';
import EcCart from '@components/icons/components/EcCart';
type PropsType = {
  isExpanded?: boolean;
};
const ProductGalleryBlockModalButton = ({
  isExpanded = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  return <span sx={styles.modalButton(isExpanded)} className="modal_product">
      <Icon color="neutralWhite" addSx={styles.cartIcon} size={['22px', '22px', '35px']}>
        <EcCart />
      </Icon>
      <span sx={styles.modalButtonText(isExpanded)}>{t('seeProducts')}</span>
    </span>;
};
export default ProductGalleryBlockModalButton;